export default {
  'pages.layouts.userLayout.title':
    '管理后台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.captcha.placeholder': '验证码',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  // welcome
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更加简洁、高效、模块化的 Golang Admin 服务，已经发布。',
  'pages.welcome.quickStart': '快速开始',
  'pages.welcome.generate': '生成结构体',
  'pages.welcome.remove': '删除结构体',
  // menu
  'pages.system.menu.add': '添加菜单',
  'pages.system.menu.edit': '编辑菜单',
  'pages.system.menu.delTip': '确定删除该菜单及其下级吗？',
  'pages.system.menu.button.addChild': '添加下级',
  'pages.system.menu.form.code': '编码',
  'pages.system.menu.form.code.placeholder': '请输入编码',
  'pages.system.menu.form.code.required': '编码是必填项！',
  'pages.system.menu.form.name': '名称',
  'pages.system.menu.form.name.placeholder': '请输入名称',
  'pages.system.menu.form.name.required': '名称是必填项！',
  'pages.system.menu.form.path': '访问路径',
  'pages.system.menu.form.sequence': '排序值',
  'pages.system.menu.form.type': '类型',
  'pages.system.menu.form.type.page': '菜单',
  'pages.system.menu.form.type.button': '按钮',
  'pages.system.menu.form.status': '状态',
  'pages.system.menu.form.status.enabled': '启用',
  'pages.system.menu.form.status.disabled': '禁用',
  'pages.system.menu.form.description': '描述',
  'pages.system.menu.form.properties': '属性',
  'pages.system.menu.form.parent_name': '上级菜单',
  'pages.system.menu.form.created_at': '创建时间',
  'pages.system.menu.form.updated_at': '更新时间',
  'pages.system.menu.resource.form.basic': '基本信息',
  'pages.system.menu.resource.form.title': 'API 资源配置',
  'pages.system.menu.resource.form.method': '请求方法',
  'pages.system.menu.resource.form.method.placeholder': '请选择请求方法',
  'pages.system.menu.resource.form.path': '请求路径',
  'pages.system.menu.resource.form.path.placeholder': '请输入请求路径 (示例：/api/admin/users/:id)',
  // role
  'pages.system.role.add': '添加角色',
  'pages.system.role.edit': '编辑角色',
  'pages.system.role.delTip': '确定删除该角色吗？',
  'pages.system.role.form.code': '编码',
  'pages.system.role.form.code.placeholder': '请输入编码',
  'pages.system.role.form.code.required': '编码是必填项！',
  'pages.system.role.form.name': '名称',
  'pages.system.role.form.name.placeholder': '请输入名称',
  'pages.system.role.form.name.required': '名称是必填项！',
  'pages.system.role.form.sequence': '排序值',
  'pages.system.role.form.status': '状态',
  'pages.system.role.form.status.enabled': '启用',
  'pages.system.role.form.status.disabled': '禁用',
  'pages.system.role.form.description': '描述',
  'pages.system.role.form.created_at': '创建时间',
  'pages.system.role.form.updated_at': '更新时间',
  'pages.system.role.form.basic': '基本信息',
  'pages.system.role.form.menu': '选择菜单权限',
  'pages.system.role.form.menu.required': '请至少选择一个菜单权限',
  // user
  'pages.system.user.add': '添加',
  'pages.system.user.edit': '编辑',
  'pages.system.user.delTip': '确定删除吗？',
  'pages.system.user.form.username': '用户名',
  'pages.system.user.form.username.placeholder': '请输入用户名',
  'pages.system.user.form.username.required': '用户名是必填项！',
  'pages.system.user.form.password': '密码',
  'pages.system.user.form.password.placeholder': '请输入密码',
  'pages.system.user.form.password.update.placeholder': '密码为空则不修改密码',
  'pages.system.user.form.name': '姓名',
  'pages.system.user.form.name.placeholder': '请输入姓名',
  'pages.system.user.form.name.required': '姓名是必填项！',
  'pages.system.user.form.email': '邮箱',
  'pages.system.user.form.email.placeholder': '请输入邮箱',
  'pages.system.user.form.phone': '手机号',
  'pages.system.user.form.phone.placeholder': '请输入手机号',
  'pages.system.user.form.roles': '所属角色',
  'pages.system.user.form.roles.placeholder': '请选择角色',
  'pages.system.user.form.roles.required': '请至少选择一个角色',
  'pages.system.user.form.remark': '备注',
  'pages.system.user.form.status': '状态',
  'pages.system.user.form.status.activated': '正常',
  'pages.system.user.form.status.freezed': '冻结',
  'pages.system.user.form.created_at': '创建时间',
  'pages.system.user.form.updated_at': '更新时间',
  // logger
  'pages.system.logger.form.level': '日志级别',
  'pages.system.logger.form.trace_id': '访问 ID',
  'pages.system.logger.form.tag': '标签',
  'pages.system.logger.form.message': '日志内容',
  'pages.system.logger.form.user_name': '用户名称',
  'pages.system.logger.form.created_at': '创建时间',
  // profile
  'pages.user.profile.tab.basic': '基本信息',
  'pages.user.profile.tab.security': '安全设置',
  'pages.user.profile.tab.security.form.old_password': '旧密码',
  'pages.user.profile.tab.security.form.old_password.placeholder': '请输入旧密码',
  'pages.user.profile.tab.security.form.old_password.required': '旧密码是必填项！',
  'pages.user.profile.tab.security.form.password': '新密码',
  'pages.user.profile.tab.security.form.password.placeholder': '请输入新密码',
  'pages.user.profile.tab.security.form.password.required': '新密码是必填项！',
  'pages.user.profile.tab.security.form.confirm_password': '确认密码',
  'pages.user.profile.tab.security.form.confirm_password.placeholder': '请确认新密码',
  'pages.user.profile.tab.security.form.confirm_password.required': '确认密码是必填项！',
  'pages.user.profile.tab.security.form.confirm_password.validator': '两次输入的密码不匹配！',
};
